export default __webpack_public_path__ + "static/media/HOAKS-TOOLS-2.a207cba5.png";